<template>
<div>
  <div class="full-height">
    <!-- <div>
    <h1>Dev in progress..!!!!</h1>
  </div> -->
    <div class="float-right">
      <el-input placeholder="Search Reports"></el-input>
    </div>
    <el-table :data="reportsData" style="width: 100%" v-loading="loading">
      <el-table-column  label="Name" width="350" prop="reportName"></el-table-column>
      <el-table-column  label="Frequency" prop="reportFrequency"></el-table-column>
      <el-table-column  label="Format" prop="format"></el-table-column>
      <el-table-column  label="Last Generated" prop="date"></el-table-column>
    </el-table>
  </div>
  <el-divider></el-divider>
  <router-view class="box grow"></router-view>
  
</div>
</template>

<script>
import PageHeaders from '@/components/layout/PageHeaders.vue'
import { mapGetters } from 'vuex'
import {
  SENDGRID_REPORT_PREFERENCES_FETCH
} from '@/store/modules/reports/sendgrid-reports.type.js'

export default {
  name: 'ReportsScheduled',
  data () {
    return {
      reportsData: [],
      loading: true
    }
  },
  methods: {
  },
  components: {
    PageHeaders
  },
  computed: {
    ...mapGetters(['userProfile', 'userReportPreferences'])
  },
  created() {
    const current = new Date()
    const currentYear = new Date()
    let currentDateObj = new Date();
    currentDateObj.setDate(currentDateObj.getDate() - (currentDateObj.getDay() + 6) % 7);
    currentDateObj.setMonth(currentDateObj.getMonth() + 1)
    let currentTimeAndDate = new Date()
    currentTimeAndDate.setDate(currentTimeAndDate.getDate())
    currentTimeAndDate.setMonth(currentTimeAndDate.getMonth() + 1)
    if (parseInt(currentTimeAndDate.getDate()) > 15) {
      current.setMonth(current.getMonth() + 1)
    }
    this.$store.dispatch(SENDGRID_REPORT_PREFERENCES_FETCH, {
      userEmail: this.userProfile.email,
      dateSelection: "user_preferences_all"
    }).then(reports => {
      for (let report of reports.data) {
        if (report === '1' || report === '15') {
          let reportEntry = {
            reportName: 'CxDR Threat Summary',
            reportFrequency: 'Monthly',
            format: 'PDF'
          }
          if (report === '1') {
            reportEntry['date'] = '01/' + current.getMonth() + '/' + currentYear.getFullYear() + ' ' + '00:00:00' 
          } else {
            reportEntry['date'] = '15/' + current.getMonth() + '/' + currentYear.getFullYear() + ' ' + '00:00:00' 
          }
          this.reportsData.push(reportEntry)
        } else if (report === 'monday') {
          let reportEntry = {
            reportName: 'CxDR Threat Summary',
            reportFrequency: 'Weekly',
            format: 'PDF'
          }
          reportEntry['date'] = currentDateObj.getDate() + '/' + currentDateObj.getMonth() + '/' + currentDateObj.getFullYear() + ' ' + '00:00:00' 
          this.reportsData.push(reportEntry)
        } else {
          let reportEntry = {
            reportName: 'CxDR Threat Summary',
            reportFrequency: 'Once',
            format: 'PDF'
          }
          let temp = report.split(" ")
          temp = temp.slice(1, 3)
          temp = temp.join(":")
          reportEntry['date'] = currentTimeAndDate.getDate() + '/' + currentTimeAndDate.getMonth() + '/' + currentTimeAndDate.getFullYear() + ' ' + temp + ':00'
          this.reportsData.push(reportEntry)
        }
      }
      this.loading = false
    })
  }
};
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.report-graph-logo {
    height: 172px;
    width: 172px;
    border-radius: 0;
}

.set-up-confluera {
    padding: 3rem 0;
}

/* remove later */
h1 {
  animation-duration: 3s;
  animation-name: slidein;
  animation-iteration-count: infinite;
}

@keyframes slidein {
  from {
    margin-left: 100%;
    width: 300%;
  }

  75% {
    font-size: 300%;
    margin-left: 25%;
    width: 150%;
  }

  to {
    margin-left: 0%;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/reports/ReportsScheduled.vue